<template>
  <Ethereum :callback="initialize" />
  <div class="myClones">
    <div class="text" v-if="loading">
      Fetching Clones...
    </div>
    <div class="cloneGrid" v-else-if="!loading && clones.length > 0">
      <Clone
        v-for="(clone, index) in clones"
        :key="index"
        :clone="clone"
        @click="navigateToOpensea(clone)"
      />
    </div>
    <div class="none" v-else>
      No clones in wallet :(
    </div>
  </div>
</template>
<script>
import Clone from './my-clones/Clone.vue';
import Ethereum from '/src/components/common/Ethereum.vue';
import initializeConfig from '/src/initialize-config';
import { useStore } from 'vuex';
import { ethers } from 'ethers';
import { ref, watch, onMounted } from 'vue';

export default {
  components: {
    Clone,
    Ethereum
  },

  setup() {
    const store = useStore();
    const loading = ref(true);
    const clones = ref([]);

    const openSeaUrl = {
      '0x1': 'https://opensea.io/assets/',
      '0x4': 'https://testnets.opensea.io/assets/'
    };

    let config;
    onMounted(async () => {
      config = await initializeConfig();
    });

    // if (store.state.mint.bucks.length === 0) loading.value = true;
    // Once the state variable changes, the watch is triggered.
    watch(
      () => store.state.mint.bucks,
      selection => {
        loading.value = false;
      }
    );

    const initialize = async () => {
      if (store.state.ethers.canSign) {
        await store.dispatch('mint/getBucks', {}, { root: true });
        clones.value = store.state.mint.bucks;
      }

      loading.value = false;
    };

    const navigateToOpensea = clone => {
      const url = `${openSeaUrl[store.state.ethers.networkId]}${
        config.itemCollections[store.state.ethers.networkId]
      }/${ethers.BigNumber.from(`0x${clone.id}`).toString()}`;

      window.open(url, '_blank');
    };

    return { initialize, loading, clones, navigateToOpensea };
  }
};
</script>
<style scoped lang="scss">
.myClones {
  height: 100%;
  overflow: scroll;
  background-color: rgba(0, 0, 0, 0.3);
  .text {
    font-size: 24;
    font-family: PressStart, sans-serif;
    height: 100%;
    text-align: center;
    margin-top: 70px;
  }

  .none {
    font-size: 24;
    font-family: PressStart, sans-serif;
    height: 100%;
    text-align: center;
    margin-top: 70px;
    color: red;
    text-shadow: 0 0 5px red;
  }

  .cloneGrid {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    padding: 30px;
    padding-bottom: 100px;
  }
}

@media (max-width: 1300px) {
  .myClones .cloneGrid {
    // grid-template-columns: 1fr 1fr 1fr;
  }
}

@media (max-width: 970px) {
  .myClones .cloneGrid {
    // grid-template-columns: 1fr 1fr;
  }
}
</style>
